import { render, staticRenderFns } from "./GraficoPizzaStatusDoacoes.vue?vue&type=template&id=60b9fadf&"
import script from "./GraficoPizzaStatusDoacoes.vue?vue&type=script&lang=js&"
export * from "./GraficoPizzaStatusDoacoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
